// extracted by mini-css-extract-plugin
export default {"switch-wrapper":"tZLzbi_RTrGynhhwdQ9B","spaced":"aoN4aNcD2BLU24XCFgja","switch":"V8u93mX15S6wCwmDqQa7"};